export interface DisplayTag {
  id: string;
  name: string;
}

// Tags arrive primary-first. A tag picked in the listing filter takes the lead
// spot (the card ribbon) and the primary moves down into the chips (#746).
export function orderTagsForFilter<T extends DisplayTag>(tags: T[], filterTagIds: string[]): T[] {
  const index = tags.findIndex((tag) => filterTagIds.includes(tag.id));
  if (index <= 0) return tags;

  return [tags[index], ...tags.slice(0, index), ...tags.slice(index + 1)];
}

export const CARD_TAG_CHIP_LIMIT = 2;

// The tag shown under a departure date: its primary tag, or - when the tour has
// tags but none is primary (#746 review) - the first one in sequence.
export function dateRibbonTag(tour: { promo_tag?: string; other_tags?: { name: string }[] }): string | undefined {
  return tour.promo_tag?.trim() || tour.other_tags?.[0]?.name || undefined;
}
